import { Color } from 'libs/end-to-end/src/types/branding/color';
import { Colors } from 'libs/end-to-end/src/types/branding/color';
import { Icon } from 'libs/end-to-end/src/types/branding/icon';
import { Icons } from 'libs/end-to-end/src/types/branding/icon';
import { PossibleDimensionSelection } from 'libs/end-to-end/src/types/databases/revisions/database-revision-schema-options';
import { DimensionDefinition } from 'libs/end-to-end/src/types/databases/dimensions/dimension-definition';
import { LevelDefinition } from 'libs/end-to-end/src/types/databases/dimensions/level-definition';

const getRandomColor = (): Color => {
  const randomIndex = Math.floor(Math.random() * Colors.length);
  return Colors[randomIndex];
};

const getRandomIcon = (): Icon => {
  const randomIndex = Math.floor(Math.random() * Icons.length);
  return Icons[randomIndex];
};

const makeDisplayName = (columnValue: string): string => {
  return columnValue
    .split(/[_-]/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const generateDimension = (
  dimensionSelection: PossibleDimensionSelection,
): DimensionDefinition => {
  return {
    columnHeaderValue: dimensionSelection.name,
    displayName: makeDisplayName(dimensionSelection.name),
    insightFormat: '$level',
    insightWithReferenceFormat: '$level and $reference',
    showBeforeEmpsOrApps: false,
    correspondingRawColumnValue: null,
    levels: generateDimensionLevels(dimensionSelection.distinctValues),
  };
};

export const generateDimensionLevels = (
  distinctValues: string[],
): LevelDefinition[] => {
  const levels: LevelDefinition[] = [];
  for (const level of distinctValues) {
    const icon = getRandomIcon();
    const color = getRandomColor();
    const displayName = makeDisplayName(level);

    levels.push({
      columnValue: level,
      displayName,
      color,
      icon,
      isPrivileged: false,
    });
  }
  return levels;
};
